import { render, staticRenderFns } from "./SysCjProjectMilestone.vue?vue&type=template&id=28d52d02"
import script from "./SysCjProjectMilestone.vue?vue&type=script&lang=js"
export * from "./SysCjProjectMilestone.vue?vue&type=script&lang=js"
import style0 from "./SysCjProjectMilestone.vue?vue&type=style&index=0&id=28d52d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports